module.exports = __webpack_public_path__ + "static/img/img_login_code.630d0b87.png";